/* Chronoscape: $0.00 -> Available on Request */
document.addEventListener('DOMContentLoaded', function () {
  var swap = function () {
    document.querySelectorAll('.price, [class*="price"]').forEach(function (el) {
      if (el.children.length === 0 && /^\s*\$0\.00(\s*USD)?\s*$/.test(el.textContent)) {
        el.textContent = 'Available on Request';
      }
    });
  };
  swap();
  new MutationObserver(swap).observe(document.body, { childList: true, subtree: true });
});
